// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_column.scss
// module id = 37
// module chunks = 0